/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IndustriesService {
    /**
     * Get all industries
     * Retrieves all industries with valid NAICS codes
     * @returns any Industries retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Industries(): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            /**
             * Industry name
             */
            indname?: string;
            /**
             * Two-digit NAICS code
             */
            naics_2?: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/industries',
        });
    }
}
